import { useEffect, useState } from 'react'

/** `Date.now()` that re-renders every `intervalMs` (SLA countdowns tick every 30 s). */
export function useNow(intervalMs = 30_000): number {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), intervalMs)
    return () => window.clearInterval(id)
  }, [intervalMs])
  return now
}
